import request from '@/api/request'
import mockData from './mock-data/opportunity-07'
import qs from 'qs'

const USE_MOCK_DATA = false

export default {
  getData (uuid) {
    const url = `/itp/client/get/${uuid}`
    if (USE_MOCK_DATA) {
      return new Promise((resolve, reject) => {
        resolve(mockData)
      })
    }
    return request({
      method: 'GET',
      url,
      headers: { 'Cache-Control': 'no-cache' }
    })
  },
  sendClientContact (payload) {
    const url = `/itp/client/contact`
    const data = qs.stringify(payload)
    const headers = { 'content-type': 'application/x-www-form-urlencoded' }
    return request({ method: 'POST', url, headers, data })
  },
  sendSignature (payload) {
    const data = [payload]
    const url = `/itp/client/signature`
    return request({ method: 'POST', url, data })
  }
}
